import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const stc: ApiFunc<`/${typeof API.STC}{id}`, 'get'> = data =>
  instance.get(`${API.STC}${'id' in data ? data.id : data.name}`)

export const stcAdmin: ApiFunc<`/${typeof API.STC_ADMIN}{id}`, 'get'> = data =>
  instance.get(`${API.STC_ADMIN}${'id' in data ? data.id : data.name}`)

export const stcAll: ApiFunc<`/${typeof API.STC_ALL}`, 'get'> = data =>
  instance.get(API.STC_ALL, {
    params: data,
  })

export const stcList: ApiFunc<`/${typeof API.STC}`, 'get'> = data =>
  instance.get(API.STC, {
    params: data,
  })

export const stcCreate: ApiFunc<`/${typeof API.STC}`, 'post'> = data => instance.post(API.STC, data)

export const stcCategoryDelete: ApiFunc<`/${typeof API.STC_CATEGORY}{id}`, 'delete'> = data =>
  instance.delete(`${API.STC_CATEGORY}${'id' in data ? data.id : data?.name}`)

export const stcCategory: ApiFunc<`/${typeof API.STC_CATEGORY}{id}`, 'get'> = data =>
  instance.get(`${API.STC_CATEGORY}${'id' in data ? data.id : ''}`)

export const stcCategoryAll: ApiFunc<`/${typeof API.STC_CATEGORY_ALL}`, 'get'> = data =>
  instance.get(API.STC_CATEGORY_ALL, {
    params: data,
  })

export const stcCategoryList: ApiFunc<`/${typeof API.STC_CATEGORY}`, 'get'> = data =>
  instance.get(API.STC_CATEGORY, {
    params: data,
  })

export const stcCategoryCreate: ApiFunc<`/${typeof API.STC_CATEGORY}`, 'post'> = data =>
  instance.post(API.STC_CATEGORY, data)

export const stcChapterList: ApiFunc<`/${typeof API.STC_CHAPTER}`, 'get'> = data =>
  instance.get(API.STC_CHAPTER, { params: data })

export const stcChapterAll: ApiFunc<`/${typeof API.STC_CHAPTER_ALL}`, 'get'> = data =>
  instance.get(API.STC_CHAPTER_ALL, { params: data })

export const stcChapterCreate: ApiFunc<`/${typeof API.STC_CHAPTER}`, 'post'> = data =>
  instance.post(API.STC_CHAPTER, data)

export const stcChapterCreateBatch: ApiFunc<`/${typeof API.STC_CHAPTER_CREATE_BATCH}`, 'post'> = data =>
  instance.post(API.STC_CHAPTER_CREATE_BATCH, data)

export const stcChapterDelete: ApiFunc<`/${typeof API.STC_CHAPTER}{id}`, 'delete'> = data =>
  instance.delete(
    `${API.STC_CHAPTER}${
      'id' in data ? data.id : 'name' in data ? data.name : 'st_course_id' in data && data.st_course_id
    }`
  )

export const stcChapter: ApiFunc<`/${typeof API.STC_CHAPTER}{id}`, 'get'> = data =>
  instance.get(
    `${API.STC_CHAPTER}${
      'id' in data ? data.id : 'name' in data ? data.name : 'st_course_id' in data && data.st_course_id
    }`
  )

export const stcTopic: ApiFunc<`/${typeof API.STC_TOPIC}{id}`, 'get'> = data =>
  instance.get(`${API.STC_TOPIC}${'id' in data ? data.id : data.name}`)

export const stcTopicDelete: ApiFunc<`/${typeof API.STC_TOPIC}{id}`, 'delete'> = data =>
  instance.delete(
    `${API.STC_TOPIC}${
      'id' in data ? data.id : 'name' in data ? data.name : 'st_course_id' in data && data.st_course_id
    }`
  )

export const stcTopicAll: ApiFunc<`/${typeof API.STC_TOPIC_ALL}`, 'get'> = data =>
  instance.get(API.STC_TOPIC_ALL, { params: data })

export const stcTopicList: ApiFunc<`/${typeof API.STC_TOPIC}`, 'get'> = data =>
  instance.get(API.STC_TOPIC, { params: data })

export const stcTopicCreate: ApiFunc<`/${typeof API.STC_TOPIC}`, 'post'> = data => instance.post(API.STC_TOPIC, data)
